import { blue } from "@mui/material/colors";
import React, { forwardRef, useCallback, useMemo } from "react";
import { colDefFilterMultiSelect } from "../../../../../utils/agGrid/colDefs/colDefFilterMultiSelect";
import BorrowerSidepanelTable from "../../shared/BorrowerSidepanelTable";

const BorrowerValidatedExperienceTable = forwardRef(
  (
    {
      quickFilter,
      rowData,
      showAll = false,
      onRowClicked,
      loading,
      activeId,
      activeApplication,
    },
    ref,
  ) => {
    const columnDefs = useMemo(
      () => [
        {
          headerName: "Address",
          field: "propertyAddress",
          width: 180,
          minWidth: 150,
          valueFormatter: (params) => {
            return params?.data?.propertyAddress?.fullAddress;
          },
        },
        {
          headerName: "Experience Type",
          field: "experienceType",
          flex: 1,
          minWidth: 150,
          // sort: "asc",
          // checkboxSelection: true,
          // headerCheckboxSelection: true,
        },
        {
          headerName: "Resolution Status",
          field: "resolutionStatus",
          width: 180,
          minWidth: 150,
        },
        {
          headerName: "Purchase Date",
          field: "propertyPurchaseDate",
          width: 130,
          type: "date",
          // valueFormatter: (params) => {
          //   return params.value ? formatDateShort(params.value) : "-";
          // },
        },
        {
          headerName: "Purchase Price",
          field: "propertyPurchasePrice",
          width: 140,
          type: "dollar",
          // valueFormatter: (params) => {
          //   return params.value ? formatDollar(params.value) : "-";
          // },
        },
        {
          headerName: "Renovation Budget",
          field: "propertyRenovationBudget",
          width: 150,
          type: "dollar",
          // valueFormatter: (params) => {
          //   return params.value ? formatDollar(params.value) : "-";
          // },
        },
        {
          headerName: "Sale Date",
          field: "propertySaleDate",
          width: 130,
          type: "date",
          // valueFormatter: (params) => {
          //   return params.value ? formatDateShort(params.value) : "-";
          // },
        },
        {
          headerName: "Sale Price",
          field: "propertySalePrice",
          width: 140,
          type: "dollar",
          // valueFormatter: (params) => {
          //   return params.value ? formatDollar(params.value) : "-";
          // },
        },
        {
          headerName: "Current Market Value",
          field: "currentMarketValue",
          width: 160,
          type: "dollar",
          // valueFormatter: (params) => {
          //   return params.value ? formatDollar(params.value) : "-";
          // },
        },
        {
          headerName: "Entity Ownership %",
          field: "borrowerEntityMembershipPercent",
          width: 150,
          type: "percent",
          // valueFormatter: (params) => {
          //   return params.value ? formatPercent(params.value) : "-";
          // },
        },
      ],
      [],
    );

    const handleOnRowClicked = useCallback((props) => {
      onRowClicked(props?.data);
    }, []);

    const defaultColDef = useMemo(() => {
      return {
        enableRowGroup: true,
        floatingFilter: false,
        filter: colDefFilterMultiSelect,
        showRowGroup: false,
        suppressHeaderFilterButton: true,
        suppressMenu: true,

        flex: 1,
        minWidth: 200,
        // cellClass: "ag-cell-vertical-center",
      };
    }, []);

    const getRowStyle = useCallback(
      (props) => {
        if (activeId === props.data?._id) {
          return {
            backgroundColor: blue[50],
          };
        }
      },
      [activeId],
    );

    return (
      <BorrowerSidepanelTable
        columnDefs={columnDefs}
        rowData={rowData}
        onRowClicked={onRowClicked}
      />
    );
  },
);
export default BorrowerValidatedExperienceTable;
